import {
	TRAVEL_LINK_LOADING,
	TRAVEL_LINK_SAVING_FAILED,
	TRAVEL_LINK_SAVING_SUCCESSED,
} from "../actions/types";
const initialState = {
	data: {},
	isLoading: false,
	saved: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case TRAVEL_LINK_LOADING:
			return {
				...state,
				isLoading: true,
				saved: false,
			};
		case TRAVEL_LINK_SAVING_SUCCESSED:
			return {
				...state,
				data: action.payload,
				isLoading: false,
				saved: true,
			};
		case TRAVEL_LINK_SAVING_FAILED:
			return {
				...state,
				isLoading: false,
				saved: false,
			};
		default:
			return state;
	}
}
